// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* style it, the bare minimum */
:root {
  --sh-modal-margin: 0px;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog {
  min-height: 150px;
  background-color: #fff !important;
  width: clamp(250px, 30vw, 90vw);
  z-index: 999;
  overflow: hidden;
  outline: 0;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 200px);
  position: relative;
  background-clip: padding-box;
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.3) !important;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 35px;
  background: var(--popupwindowheadbg);
  box-shadow: 0px 1px 0px var(--primaryColor);
}

.dialog-title {
  text-align: center !important;
  width: 100%;
  font-size: 1rem !important;
  color: #fff !important;
  padding: 10px;
}

.dialog-body {
  position: relative;
  flex: 1 1 auto;
  padding: 15px;
  overflow-y: auto;
  min-height: 50px;
  color: #252525 !important;
  font-size: 1rem !important;
  text-align: left;
  padding-top: 15px 15px;
}

.dialog-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-end;
  column-gap: normal;
  padding: 10px;
}
.dialog-footer .btn {
  --bs-btn-line-height: 1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--popupwindowheadbg);
  margin-right: 15px;
  border: none;
  cursor: pointer;
}
.dialog-footer .btn:first-child {
  background: #fff;
  color: #363636;
  border: 1px solid #dbdbdb;
}

/* extra styles and animation */
.dialog-bottom-sheet .dialog-overlay {
  align-items: flex-end;
}

.dialog-full-height .dialog {
  height: calc(100vh - var(--sh-modal-margin) * 2);
}

.dialog-full-screen .dialog {
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
}

.dialog-half-screen .dialog-overlay {
  justify-content: flex-start;
}

.dialog-half-screen .dialog {
  max-width: 50vw;
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
}

.reverse .dialog-overlay {
  justify-content: flex-end;
}

.animate.fromleft .dialog {
  transform: translateX(-100%);
  animation: fromleft 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

.animate.fromright .dialog {
  transform: translateX(100%);
  animation: fromright 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

.animate.fromtop .dialog {
  transform: translateY(-100%);
  animation: fromtop 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

.animate.frombottom .dialog {
  transform: translateY(100%);
  animation: frombottom 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

@keyframes fromleft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes fromright {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes frombottom {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes fromtop {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
.e-library-modal .modal-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  background: #fff;
  animation: slideUp 0.3s ease-out;
}
.e-library-modal .modal-card-head {
  background: linear-gradient(90deg, #3273dc, #485fc7);
  color: #fff;
  border-bottom: none;
}
.e-library-modal .modal-card-head .modal-card-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
}
.e-library-modal .modal-card-head .delete {
  background: rgba(255, 255, 255, 0.2);
}
.e-library-modal .modal-card-head .delete:hover {
  background: rgba(255, 255, 255, 0.4);
}
.e-library-modal .modal-card-body {
  padding: 1.5rem 2rem;
  background: #f9fafb;
}
.e-library-modal .modal-card-body .upload-section {
  margin-bottom: 1.5rem;
}
.e-library-modal .modal-card-body .upload-section .upload-box {
  border: 2px dashed #b5b5b5;
  border-radius: 10px;
  padding: 2rem;
  text-align: center;
  background: #fff;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
}
.e-library-modal .modal-card-body .upload-section .upload-box:hover {
  border-color: #3273dc;
  background: #f0f4ff;
}
.e-library-modal .modal-card-body .upload-section .upload-box.has-file {
  border: 1px solid #ddd;
  background: #fdfdfd;
}
.e-library-modal .modal-card-body .upload-section .upload-box .empty-state {
  width: 80px;
  opacity: 0.6;
  margin-bottom: 1rem;
}
.e-library-modal .modal-card-body .upload-section .upload-box .upload-trigger {
  color: #3273dc;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.e-library-modal .modal-card-body .upload-section .upload-box .upload-trigger i {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}
.e-library-modal .modal-card-body .upload-section .upload-box .file-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #eef2ff;
  border-radius: 8px;
}
.e-library-modal .modal-card-body .upload-section .upload-box .file-preview .file-icon {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.95rem;
}
.e-library-modal .modal-card-body .upload-section .upload-box .file-preview .file-icon .file-name {
  font-weight: 500;
  color: #363636;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.e-library-modal .modal-card-body .upload-section .upload-box .file-preview .file-icon .delete {
  background: transparent;
  margin-left: 10px;
}
.e-library-modal .modal-card-body .upload-section .upload-box .file-preview .file-icon .delete:hover {
  color: #ff3860;
}
.e-library-modal .modal-card-foot {
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 1rem 2rem;
}
.e-library-modal .modal-card-foot .button {
  border-radius: 6px;
}
.e-library-modal .modal-card-foot .button.is-link {
  background: linear-gradient(90deg, #3273dc, #485fc7);
  border: none;
}
.e-library-modal .modal-card-foot .button.is-link:hover {
  background: linear-gradient(90deg, #485fc7, #3273dc);
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/confirmation-dialog/confirmation-dialog.component.scss"],"names":[],"mappings":"AAAA,+BAAA;AAEA;EACE,sBAAA;AAAF;;AAGA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAIA;EACE,iBAAA;EACA,iCAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,4BAAA;EACA,kIAAA;AADF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,oCAAA;EACA,2CAAA;AAFF;;AAKA;EACE,6BAAA;EACA,WAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;AAFF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;AAHF;AAKE;EACE,oCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAHJ;AAME;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AAJJ;;AAQA,+BAAA;AAEA;EACE,qBAAA;AANF;;AASA;EACE,gDAAA;AANF;;AASA;EACE,sCAAA;EACA,sCAAA;EACA,YAAA;AANF;;AASA;EACE,2BAAA;AANF;;AASA;EACE,eAAA;EACA,sCAAA;EACA,sCAAA;AANF;;AASA;EACE,yBAAA;AANF;;AASA;EACE,4BAAA;EACA,oDAAA;EACA,6BAAA;AANF;;AASA;EACE,2BAAA;EACA,qDAAA;EACA,6BAAA;AANF;;AASA;EACE,4BAAA;EACA,mDAAA;EACA,6BAAA;AANF;;AASA;EACE,2BAAA;EACA,sDAAA;EACA,6BAAA;AANF;;AASA;EACE;IACE,4BAAA;EANF;EASA;IACE,wBAAA;EAPF;AACF;AAUA;EACE;IACE,2BAAA;EARF;EAWA;IACE,wBAAA;EATF;AACF;AAYA;EACE;IACE,2BAAA;EAVF;EAaA;IACE,wBAAA;EAXF;AACF;AAcA;EACE;IACE,4BAAA;EAZF;EAeA;IACE,wBAAA;EAbF;AACF;AAiBE;EACE,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gCAAA;AAfJ;AAkBE;EACE,oDAAA;EACA,WAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAhBN;AAmBI;EACE,oCAAA;AAjBN;AAmBM;EACE,oCAAA;AAjBR;AAsBE;EACE,oBAAA;EACA,mBAAA;AApBJ;AAsBI;EACE,qBAAA;AApBN;AAsBM;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AApBR;AAsBQ;EACE,qBAAA;EACA,mBAAA;AApBV;AAuBQ;EACE,sBAAA;EACA,mBAAA;AArBV;AAwBQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAtBV;AAyBQ;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAvBV;AAyBU;EACE,iBAAA;EACA,qBAAA;AAvBZ;AA2BQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAzBV;AA2BU;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAzBZ;AA2BY;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzBd;AA4BY;EACE,uBAAA;EACA,iBAAA;AA1Bd;AA4Bc;EACE,cAAA;AA1BhB;AAmCE;EACE,gBAAA;EACA,6BAAA;EACA,kBAAA;AAjCJ;AAmCI;EACE,kBAAA;AAjCN;AAmCM;EACE,oDAAA;EACA,YAAA;AAjCR;AAmCQ;EACE,oDAAA;AAjCV;;AAwCA;EACE;IACE,2BAAA;IACA,UAAA;EArCF;EAwCA;IACE,wBAAA;IACA,UAAA;EAtCF;AACF","sourcesContent":["/* style it, the bare minimum */\n\n:root {\n  --sh-modal-margin: 0px;\n}\n\n.dialog-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 99999;\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n}\n\n.dialog {\n  min-height: 150px;\n  background-color: #fff !important;\n  width: clamp(250px, 30vw, 90vw);\n  z-index: 999;\n  overflow: hidden;\n  outline: 0;\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 100px * 2);\n  position: relative;\n  background-clip: padding-box;\n  box-shadow: 0 16px 24px 2px rgba(#000, 0.14), 0 6px 30px 5px rgba(#000, 0.12),\n    0 8px 10px -5px rgba(#000, 0.3) !important;\n}\n\n.dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 35px;\n  background: var(--popupwindowheadbg);\n  box-shadow: 0px 1px 0px var(--primaryColor);\n}\n\n.dialog-title {\n  text-align: center !important;\n  width: 100%;\n  font-size: 1rem !important;\n  color: #fff !important;\n  padding: 10px;\n\n}\n\n.dialog-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 15px;\n  overflow-y: auto;\n  min-height: 50px;\n  color: #252525 !important;\n  font-size: 1rem !important;\n  text-align: left;\n  padding-top: 15px 15px;\n}\n\n.dialog-footer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: flex-end;\n  column-gap: normal;\n  padding: 10px;\n\n  .btn {\n    --bs-btn-line-height: 1.2 !important;\n    font-size: .9rem !important;\n    padding: 5px 20px;\n    color: #fff;\n    background: var(--popupwindowheadbg);\n    margin-right: 15px;\n    border: none;\n    cursor: pointer;\n  }\n\n  .btn:first-child {\n    background: #fff;\n    color: #363636;\n    border: 1px solid #dbdbdb;\n  }\n}\n\n/* extra styles and animation */\n\n.dialog-bottom-sheet .dialog-overlay {\n  align-items: flex-end;\n}\n\n.dialog-full-height .dialog {\n  height: calc(100vh - var(--sh-modal-margin) * 2);\n}\n\n.dialog-full-screen .dialog {\n  min-height: calc(var(--vh, 1vh) * 100);\n  max-height: calc(var(--vh, 1vh) * 100);\n  width: 100vw;\n}\n\n.dialog-half-screen .dialog-overlay {\n  justify-content: flex-start;\n}\n\n.dialog-half-screen .dialog {\n  max-width: 50vw;\n  min-height: calc(var(--vh, 1vh) * 100);\n  max-height: calc(var(--vh, 1vh) * 100);\n}\n\n.reverse .dialog-overlay {\n  justify-content: flex-end;\n}\n\n.animate.fromleft .dialog {\n  transform: translateX(-100%);\n  animation: fromleft 0.15s var(--sh-trans-func) 0.15s;\n  animation-fill-mode: forwards;\n}\n\n.animate.fromright .dialog {\n  transform: translateX(100%);\n  animation: fromright 0.15s var(--sh-trans-func) 0.15s;\n  animation-fill-mode: forwards;\n}\n\n.animate.fromtop .dialog {\n  transform: translateY(-100%);\n  animation: fromtop 0.15s var(--sh-trans-func) 0.15s;\n  animation-fill-mode: forwards;\n}\n\n.animate.frombottom .dialog {\n  transform: translateY(100%);\n  animation: frombottom 0.15s var(--sh-trans-func) 0.15s;\n  animation-fill-mode: forwards;\n}\n\n@keyframes fromleft {\n  from {\n    transform: translateX(-100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes fromright {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes frombottom {\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes fromtop {\n  from {\n    transform: translateY(-100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n.e-library-modal {\n  .modal-card {\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n    background: #fff;\n    animation: slideUp 0.3s ease-out;\n  }\n\n  .modal-card-head {\n    background: linear-gradient(90deg, #3273dc, #485fc7);\n    color: #fff;\n    border-bottom: none;\n\n    .modal-card-title {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      font-size: 1.1rem;\n    }\n\n    .delete {\n      background: rgba(255, 255, 255, 0.2);\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.4);\n      }\n    }\n  }\n\n  .modal-card-body {\n    padding: 1.5rem 2rem;\n    background: #f9fafb;\n\n    .upload-section {\n      margin-bottom: 1.5rem;\n\n      .upload-box {\n        border: 2px dashed #b5b5b5;\n        border-radius: 10px;\n        padding: 2rem;\n        text-align: center;\n        background: #fff;\n        transition: all 0.3s ease;\n        position: relative;\n        cursor: pointer;\n\n        &:hover {\n          border-color: #3273dc;\n          background: #f0f4ff;\n        }\n\n        &.has-file {\n          border: 1px solid #ddd;\n          background: #fdfdfd;\n        }\n\n        .empty-state {\n          width: 80px;\n          opacity: 0.6;\n          margin-bottom: 1rem;\n        }\n\n        .upload-trigger {\n          color: #3273dc;\n          font-weight: 500;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n\n          i {\n            font-size: 1.5rem;\n            margin-bottom: 0.5rem;\n          }\n        }\n\n        .file-preview {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          gap: 1rem;\n          padding: 1rem;\n          background: #eef2ff;\n          border-radius: 8px;\n\n          .file-icon {\n            display: flex;\n            align-items: center;\n            gap: 0.75rem;\n            font-size: 0.95rem;\n\n            .file-name {\n              font-weight: 500;\n              color: #363636;\n              max-width: 200px;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n\n            .delete {\n              background: transparent;\n              margin-left: 10px;\n\n              &:hover {\n                color: #ff3860;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .modal-card-foot {\n    background: #fff;\n    border-top: 1px solid #f0f0f0;\n    padding: 1rem 2rem;\n\n    .button {\n      border-radius: 6px;\n\n      &.is-link {\n        background: linear-gradient(90deg, #3273dc, #485fc7);\n        border: none;\n\n        &:hover {\n          background: linear-gradient(90deg, #485fc7, #3273dc);\n        }\n      }\n    }\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
